import React, { useContext, useEffect, useState } from 'react'
import { addcontext } from '../../ContextShare/ContextShare'
import { GetPartVideos, GetPartVideosBS, GetPartVideosGA, GetPartVideosRL } from '../../Services/allApi'
import { useNavigate, useParams } from 'react-router-dom'

function PartVideos() {
    const params=useParams()
    const videoIdFromUrl=params.vId
    const [vIdToUrl,setvIdToUrl]=useState()
    const {videoData,setVideoData}=useContext(addcontext)
    const {videoUrl,setVideoUrl}=useContext(addcontext)
    const {videoThumb,setVideoThumb}=useContext(addcontext)
    const {whichPageIsSendingData,setwhichPageIsSendingData}=useContext(addcontext)
    const {isPartAVailable,setIsPartAVailable}=useContext(addcontext)
    const [parVideos,setparVideos]=useState([])
    const [response,setResponse]=useState(1)
    const {isPartClicked,setisPartClicked}=useContext(addcontext)
    const {newIdP,setnewIdP}=useContext(addcontext)
    useEffect(()=>{
        const newId=videoIdFromUrl?.replace(/:/g, '')
        setvIdToUrl(newId)
        if(newId){
          console.log(vIdToUrl);
          GetDetailsOFVideo(newId)
        }
      },[vIdToUrl,newIdP])

      const navigate=useNavigate()
    // get the details call api by mapping id taken from url
      const GetDetailsOFVideo=async(newId)=>{
       const result = await GetPartVideos(newId);
        setparVideos(result?.data?.data?.all_parts);
    
    //    if(vIdToUrl){
    //     navigate(`/video/:${vIdToUrl}`);
    // }
      }


//     const partVideoApi = async () => {
//     if (whichPageIsSendingData === 'govaddroilkesss') {
//         const result = await GetPartVideosGA(videoData?.mapping_id);
//         console.log(result);
//         // const sortedParts = result?.data?.data?.parts.sort((a, b) => a.part_order - b.part_order);
//         // const avoid =sortedParts.filter((filtered)=> filtered.part_order!=videoData.part_order);
//         setparVideos(result?.data?.data?.all_parts);
//     }
//     else if (whichPageIsSendingData === 'budgetspoleechhh') {
//         const result = await GetPartVideosBS(videoData?.mapping_id);
//         console.log(result);
//         // const sortedParts = result?.data?.data?.parts.sort((a, b) => a.part_order - b.part_order);
//         setparVideos(result?.data?.data?.all_parts);
//     }
//     else if(whichPageIsSendingData==='rulinolgss'){
//         const result = await GetPartVideosRL(videoData?.mapping_id);
//         setparVideos(result?.data?.data?.all_parts);
//     }
//     else{
//         const result = await GetPartVideos(videoData?.mapping_id);
//         setparVideos(result?.data?.data?.all_parts);
//     }


// }

// change part count showing
const handlePartChange=async(parts)=>{

    // setVideoData(parts)
    setResponse(response+1)
    const result = await GetPartVideos(parts?.mapping_id);
    setparVideos(result?.data?.data?.all_parts);
    // setisPartClicked(isPartClicked+1)
    setisPartClicked((prevIsPartClicked) => prevIsPartClicked + 1);

    console.log(isPartClicked);
    // setnewIdP(parts?.mapping_id)
    // // partVideoApi()
    // setVideoUrl(parts?.video_url)
    // if(whichPageIsSendingData=='govaddress'){
    //     setVideoThumb(parts.address_thumbnail)
    // }
    // else if(whichPageIsSendingData=='budgetspeech'){
    //     setVideoThumb(parts.speech_thumbnail)
    // }
    // else if(whichPageIsSendingData=='rulings'){
    //     setVideoThumb(parts.rulings_thumbnail)
    // }
    // else{
    // setVideoThumb(parts.video_thumbnail)
    // }
    navigate(`/video/:${parts?.mapping_id}`);
    //    if(videoData?.mapping_id){
//     navigate(`/video/:${videoData?.mapping_id}`);
// }


}

    // useEffect(()=>{
    //     partVideoApi()
    // },[response,videoData])

    
  return (
    <div className='mt-10 flex justify-center flex-row flex-wrap w-9/12 '>

    {parVideos?.length>0&&parVideos.map((parts)=>(
     <div className='me-5 hover:shadow-md flex flex-col justify-center items-center xl:w-1/12 lg:w-2/12 md:w-2/12 sm:w-4/12 w-5/12 h-full border mb-2 bg-success rounded-lg transform duration-500 ease-out'>
       <p className='mt-1'>Part {parts?.part_order}</p>
       {/* <p className='bg-black bg-opacity-15 rounded px-1'>23:05</p> */}
       <p className='cursor-pointer mb-1 hover:underline text-blue-500' onClick={(e)=>handlePartChange(parts)}>Watch now</p>
     </div>
    )) }
     
     
   </div>
  )
}

export default PartVideos